import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import * as types from '../mutation-types';
import kaptionDeliveryWebhooksAPI from '../../api/kaptionDeliveryWebhooks';

const state = {
  records: [],
  uiFlags: {
    fetchingList: false,
    fetchingItem: false,
    creatingItem: false,
    updatingItem: false,
    deletingItem: false,
  },
};

export const getters = {
  getWebhooks(_state) {
    return _state.records.sort((a, b) => b.id - a.id);
  },
  getWebhook: _state => id => {
    return _state.records.find(webhook => webhook.id === Number(id));
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
};

export const actions = {
  async get({ commit }) {
    commit(types.default.SET_KAPTION_DELIVERY_WEBHOOK_UI_FLAG, {
      fetchingList: true,
    });
    try {
      const response = await kaptionDeliveryWebhooksAPI.getAll();
      commit(types.default.SET_KAPTION_DELIVERY_WEBHOOKS, response.data);
    } catch (error) {
      // Handle error silently
    } finally {
      commit(types.default.SET_KAPTION_DELIVERY_WEBHOOK_UI_FLAG, {
        fetchingList: false,
      });
    }
  },

  async create({ commit }, params) {
    commit(types.default.SET_KAPTION_DELIVERY_WEBHOOK_UI_FLAG, {
      creatingItem: true,
    });
    try {
      const response = await kaptionDeliveryWebhooksAPI.create(params);
      commit(types.default.ADD_KAPTION_DELIVERY_WEBHOOK, response.data);
      return response.data;
    } finally {
      commit(types.default.SET_KAPTION_DELIVERY_WEBHOOK_UI_FLAG, {
        creatingItem: false,
      });
    }
  },

  async update({ commit }, { id, ...updateObj }) {
    commit(types.default.SET_KAPTION_DELIVERY_WEBHOOK_UI_FLAG, {
      updatingItem: true,
    });
    try {
      const response = await kaptionDeliveryWebhooksAPI.update(id, updateObj);
      commit(types.default.UPDATE_KAPTION_DELIVERY_WEBHOOK, response.data);
      return response.data;
    } finally {
      commit(types.default.SET_KAPTION_DELIVERY_WEBHOOK_UI_FLAG, {
        updatingItem: false,
      });
    }
  },

  async revoke({ commit }, id) {
    commit(types.default.SET_KAPTION_DELIVERY_WEBHOOK_UI_FLAG, {
      deletingItem: true,
    });
    try {
      await kaptionDeliveryWebhooksAPI.revoke(id);
      commit(types.default.DELETE_KAPTION_DELIVERY_WEBHOOK, id);
    } finally {
      commit(types.default.SET_KAPTION_DELIVERY_WEBHOOK_UI_FLAG, {
        deletingItem: false,
      });
    }
  },

  async rotate({ commit }, id) {
    commit(types.default.SET_KAPTION_DELIVERY_WEBHOOK_UI_FLAG, {
      updatingItem: true,
    });
    try {
      const response = await kaptionDeliveryWebhooksAPI.rotate(id);
      commit(types.default.DELETE_KAPTION_DELIVERY_WEBHOOK, id);
      commit(types.default.ADD_KAPTION_DELIVERY_WEBHOOK, response.data);
      return response.data;
    } finally {
      commit(types.default.SET_KAPTION_DELIVERY_WEBHOOK_UI_FLAG, {
        updatingItem: false,
      });
    }
  },

  async test(_, id) {
    const response = await kaptionDeliveryWebhooksAPI.test(id);
    return response.data;
  },
};

export const mutations = {
  [types.default.SET_KAPTION_DELIVERY_WEBHOOK_UI_FLAG](_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
  [types.default.SET_KAPTION_DELIVERY_WEBHOOKS]: MutationHelpers.set,
  [types.default.ADD_KAPTION_DELIVERY_WEBHOOK]: MutationHelpers.create,
  [types.default.UPDATE_KAPTION_DELIVERY_WEBHOOK]: MutationHelpers.update,
  [types.default.DELETE_KAPTION_DELIVERY_WEBHOOK]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
